export default {
  state: {
    dataList: [
      // {
      //   name: '主动标识载体的技术与应用',
      //   video: 'video/training-practice/lecture-hall/主动标识载体的技术与应用.mp4',
      //   img: 'video/training-practice/lecture-hall/主动标识载体的技术与应用.png',
      // },
      // {
      //   name: '区块链上链设备与芯片研究',
      //   video: 'video/training-practice/lecture-hall/区块链上链设备与芯片研究.mp4',
      //   img: 'video/training-practice/lecture-hall/区块链上链设备与芯片研究.png',
      // },
      // {
      //   name: '区块链数据模型与存储研究',
      //   video: 'video/training-practice/lecture-hall/区块链数据模型与存储研究.mp4',
      //   img: 'video/training-practice/lecture-hall/区块链数据模型与存储研究.png',
      // },
      // {
      //   name: '区块链跨链与接入技术研究',
      //   video: 'video/training-practice/lecture-hall/区块链跨链与接入技术研究.mp4',
      //   img: 'video/training-practice/lecture-hall/区块链跨链与接入技术研究.png',
      // },
      // {
      //   name: '工业互联网标识与工业软件',
      //   video: 'video/training-practice/lecture-hall/工业互联网标识与工业软件.mp4',
      //   img: 'video/training-practice/lecture-hall/工业互联网标识与工业软件.png',
      // },
      // {
      //   name: '工业互联网标识的行业编码方法与进展',
      //   video: 'video/training-practice/lecture-hall/工业互联网标识的行业编码方法与进展.mp4',
      //   img: 'video/training-practice/lecture-hall/工业互联网标识的行业编码方法与进展.png',
      // },
      // {
      //   name: '工业互联网标识解析体系架构',
      //   video: 'video/training-practice/lecture-hall/工业互联网标识解析体系架构.mp4',
      //   img: 'video/training-practice/lecture-hall/工业互联网标识解析体系架构.png',
      // },
      // {
      //   name: '标识解析体系安全认证的技术与系统',
      //   video: 'video/training-practice/lecture-hall/标识解析体系安全认证的技术与系统.mp4',
      //   img: 'video/training-practice/lecture-hall/标识解析体系安全认证的技术与系统.png',
      // },
    ]
  }
}
